module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "banner"
  }, [_c('ul', {
    directives: [{
      name: "ban",
      rawName: "v-ban"
    }]
  }, _vm._l((_vm.imgs), function(img) {
    return _c('li', [_c('img', {
      attrs: {
        "src": img.image
      }
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, _vm._l((_vm.imgs), function(img) {
    return _c('span')
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-b658e0c6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-b658e0c6","hasScoped":true}!./node_modules/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./app/component/pswiper.vue
// module id = 105
// module chunks = 0